import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
                <i className="ri-article-line"></i>
                深度爆料
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
                最新吃瓜深度报道
              </h2>
            </div>
          </div>

          <div className="space-y-5">
            {cardItems.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col sm:flex-row gap-5 bg-background-50 border border-background-200 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="flex-shrink-0 w-full sm:w-64 md:w-72 h-48 sm:h-44 overflow-hidden rounded-lg">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="288"
                    height="176"
                  />
                </div>
                <div className="flex-1 flex flex-col justify-between min-w-0">
                  <div>
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      <span className="px-2 py-0.5 text-xs font-medium text-primary-600 bg-primary-100 rounded">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </div>
                    <h3 className="font-sans font-bold text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 line-clamp-2">
                      {item.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.views} 阅读
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {item.comments} 评论
                    </span>
                    <span className="flex items-center gap-1 text-primary-500 cursor-pointer">
                      <i className="ri-share-forward-line"></i>
                      分享
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}